import { doc, runTransaction } from 'firebase/firestore';

const snapshotExists = (snapshot) => (
  typeof snapshot?.exists === 'function' ? snapshot.exists() : Boolean(snapshot?.exists)
);

export const buildNotificationCounterUpdate = (clientData = {}, kind) => {
  const notificationsUnread = Math.max(0, Number(clientData.notificationsUnread || 0) - 1);
  const newUpdateCount = kind === 'sheet_update'
    ? Math.max(0, Number(clientData.newUpdateCount || 0) - 1)
    : Number(clientData.newUpdateCount || 0);

  const notifCounts = { ...(clientData.notifCounts || {}) };
  if (kind && Object.prototype.hasOwnProperty.call(notifCounts, kind)) {
    const nextCount = Math.max(0, Number(notifCounts[kind] || 0) - 1);
    if (nextCount > 0) {
      notifCounts[kind] = nextCount;
    } else {
      delete notifCounts[kind];
    }
  }

  return {
    notificationsUnread,
    newUpdateCount,
    notifCounts
  };
};

export const deleteNotificationWithCounters = async ({ db, uid, clientId, notificationId }) => {
  if (!db || !uid || !clientId || !notificationId) return false;

  const clientRef = doc(db, 'users', uid, 'clients', clientId);
  const notificationRef = doc(db, 'users', uid, 'clients', clientId, 'notifications', notificationId);

  return runTransaction(db, async (transaction) => {
    const notificationSnapshot = await transaction.get(notificationRef);
    if (!snapshotExists(notificationSnapshot)) return false;

    const clientSnapshot = await transaction.get(clientRef);
    const notificationData = notificationSnapshot.data?.() || {};
    const clientData = snapshotExists(clientSnapshot) ? (clientSnapshot.data?.() || {}) : {};
    const kind = notificationData.kind || notificationData.type || null;

    transaction.delete(notificationRef);
    transaction.set(clientRef, buildNotificationCounterUpdate(clientData, kind), { merge: true });
    return true;
  });
};
